import { useZero } from "@rocicorp/zero/react";
import { useCallback, useEffect } from "react";
import { sharedMutators } from "../../shared/mutators";

const presenceHeartbeatMs = 2_000;

export function useSetPresence(
  workflowId: string,
  branchId?: string,
  stepDir?: string
) {
  const z = useZero();

  const setPresence = useCallback(() => {
    if (!branchId || document.hidden) return;
    z.mutate(sharedMutators.touchPresence({ workflowId, branchId, stepDir }));
  }, [z, workflowId, branchId, stepDir]);

  useEffect(() => {
    setPresence();
    const id = window.setInterval(setPresence, presenceHeartbeatMs);
    return () => window.clearInterval(id);
  }, [setPresence]);

  useEffect(() => {
    document.addEventListener("visibilitychange", setPresence);
    return () => document.removeEventListener("visibilitychange", setPresence);
  }, [setPresence]);
}
